import { c as _c } from "react/compiler-runtime";
const MailUnreadIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fill="currentColor" d="M13.64 5.396A2 2 0 1 0 11.062 3q-.062.24-.063.5a2 2 0 0 0 2.64 1.896M4 3h6.041q-.04.245-.041.5c0 1.285.808 2.381 1.944 2.809L8 8.432l-6-3.23V5a2 2 0 0 1 2-2m10 3.337L8.237 9.44a.5.5 0 0 1-.474 0L2 6.337V11a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2z" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== className) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" className={className}>{t1}</svg>;
    $[1] = className;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
export default MailUnreadIcon;